module.exports = __webpack_public_path__ + "static/media/image-09-full.31fdfa83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-09-full.jpg
// module id = 356
// module chunks = 0